import { Card, Typography } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
const { Paragraph } = Typography;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'user' implicitly has an 'any' type.
function FacilityAppLinksCard({ user }) {
  const appDomain = `https://${window.location.hostname}`;
  const profileLink = `${appDomain}/calendar?userId=${user._id}&drawer=Facility`;

  return (
    <Card title="Workplace App Links">
      <Paragraph copyable={{ text: profileLink }}>Workplace Profile Link</Paragraph>
      <hr />
    </Card>
  );
}

export { FacilityAppLinksCard };
